module.exports = "<container></container>\n"